import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "7 17 2 12 7 7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "12 17 7 12 12 7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M22 18v-2a4 4 0 0 0-4-4H7", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ReplyAll";
const ReplyAll = memo(themed(Icon));
export {
  ReplyAll
};
//# sourceMappingURL=reply-all.js.map
